import jwt from "jsonwebtoken";

const jwtPubKey = process.env.REACT_APP_JWT_PUBLIC_KEY;

export default function jwtDecode(token) {
  return jwt.verify(token, jwtPubKey, { algorithms: ['RS256'] });
}
